export default "__VITE_ASSET__DKVS9vdl__"